/* eslint-disable @typescript-eslint/no-explicit-any */
import { logger } from "@helpers/logger";
import axios, { AxiosResponse } from "axios";

const baseUrl: string = process.env.NEXT_PUBLIC_BASE_URL || "/";
const basicAuth: string = process.env.NEXT_PUBLIC_BASIC_AUTH || "";

export const callAPI = async ({ method, uri, params = {}, additionalHeader }: any) => {
  const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Basic ${basicAuth}`,
  };

  const url = `${baseUrl}/${uri}`;

  const headers = { ...defaultHeaders, ...additionalHeader };

  const dataOrParams = ["GET"].includes(method.toUpperCase()) ? "params" : "data";
  const defaultConfig = { method, headers, url };
  const config = { ...defaultConfig, [dataOrParams]: params };

  try {
    const response: AxiosResponse = await axios(config);
    return response;
  } catch (error: unknown) {
    let err;

    if (axios.isAxiosError(error) && error.response) {
      if (error.response?.status >= 400) {
        err = logger.error(error);
      }
      if (error.response?.status >= 500) {
        err = logger.info(error);
      }
    } else if (error instanceof Error) {
      err = logger.error(error);
    } else {
      throw new Error(`${error}`);
    }

    return err;
  }
};
